"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var node_1 = __importDefault(require("./node"));
var type_1 = __importDefault(require("./type"));
var CommentNode = /** @class */function (_super) {
  __extends(CommentNode, _super);
  function CommentNode(rawText, parentNode, range, rawTagName) {
    if (parentNode === void 0) {
      parentNode = null;
    }
    if (rawTagName === void 0) {
      rawTagName = '!--';
    }
    var _this = _super.call(this, parentNode, range) || this;
    _this.rawText = rawText;
    _this.rawTagName = rawTagName;
    /**
     * Node Type declaration.
     * @type {Number}
     */
    _this.nodeType = type_1.default.COMMENT_NODE;
    return _this;
  }
  CommentNode.prototype.clone = function () {
    return new CommentNode(this.rawText, null, undefined, this.rawTagName);
  };
  Object.defineProperty(CommentNode.prototype, "text", {
    /**
     * Get unescaped text value of current node and its children.
     * @return {string} text content
     */
    get: function () {
      return this.rawText;
    },
    enumerable: false,
    configurable: true
  });
  CommentNode.prototype.toString = function () {
    return "<!--".concat(this.rawText, "-->");
  };
  return CommentNode;
}(node_1.default);
exports.default = CommentNode;